import {Button} from "primereact/button";

type Properties = {
    label: string
    onClick?: () => void
    disabled: boolean
}

function PropertyLink(props: Properties) {

    function handleOnClick(e: any) {
        if (props.onClick) {
            props.onClick()
        }
        e.currentTarget.blur();
    }

    return (<>
        <div className={"property-element"}>
            <Button
                className={"link"}
                link={true}
                label={props.label}
                onClick={handleOnClick}
                disabled={props.disabled}
            />
        </div>
    </>)
}

export default PropertyLink